import React from 'react';

export function SkeletonProjectCard() {
  return (
    <div className="card h-full flex flex-col border-l-2 border-l-gold/20 animate-pulse">
      <div className="h-5 bg-white/10 rounded w-2/3 mb-3"></div>
      <div className="space-y-2 flex-1 mb-4">
        <div className="h-3.5 bg-white/5 rounded w-full"></div>
        <div className="h-3.5 bg-white/5 rounded w-5/6"></div>
        <div className="h-3.5 bg-white/5 rounded w-4/6"></div>
      </div>
      <div className="flex gap-2 mb-4">
        <div className="h-5 bg-white/5 rounded w-16"></div>
        <div className="h-5 bg-white/5 rounded w-20"></div>
        <div className="h-5 bg-white/5 rounded w-14"></div>
      </div>
      <div className="h-4 bg-gold/20 rounded w-24 mt-auto"></div>
    </div>
  );
}

export function SkeletonJobTimeline() {
  return (
    <div className="relative card mb-4 border border-white/5 animate-pulse">
      <div className="absolute -left-[calc(1.5rem+5px)] top-6 w-2.5 h-2.5 rounded-full bg-gold/40"></div>
      <div className="h-5 bg-white/10 rounded w-1/2 mb-2"></div>
      <div className="flex justify-between items-center mb-3">
        <div className="h-3 bg-white/5 rounded w-24"></div>
        <div className="h-3 bg-gold/20 rounded w-28"></div>
      </div>
      <div className="space-y-1.5">
        <div className="h-3.5 bg-white/5 rounded w-full"></div>
        <div className="h-3.5 bg-white/5 rounded w-11/12"></div>
      </div>
    </div>
  );
}

export function SkeletonTechGrid() {
  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(180px,1fr))] gap-3 max-[768px]:grid-cols-[repeat(auto-fill,minmax(140px,1fr))]">
      {[...Array(8)].map((_, i) => (
        <div
          key={i}
          className="flex flex-col items-center justify-center p-4 border border-white/5 rounded-xl bg-white/[0.02] animate-pulse h-24"
        >
          <div className="w-8 h-8 rounded-full bg-white/10 mb-2"></div>
          <div className="h-3 bg-white/10 rounded w-16"></div>
        </div>
      ))}
    </div>
  );
}

export function SkeletonBlogPost() {
  return (
    <div className="card border border-white/5 animate-pulse p-6">
      <div className="h-6 bg-white/10 rounded w-3/4 mb-3"></div>
      <div className="flex gap-2 mb-4">
        <div className="h-4 bg-gold/20 rounded w-16"></div>
        <div className="h-4 bg-white/5 rounded w-20"></div>
      </div>
      <div className="space-y-2">
        <div className="h-3.5 bg-white/5 rounded w-full"></div>
        <div className="h-3.5 bg-white/5 rounded w-5/6"></div>
        <div className="h-3.5 bg-white/5 rounded w-4/6"></div>
      </div>
    </div>
  );
}
